import { MediaDevices } from "./media-devices-utils";

export function getLocalVideoSharingSources(mediaDevicesManager) {
  const mediaStream = mediaDevicesManager?.mediaStream;
  const videoTracks = mediaStream?.getVideoTracks?.() || [];
  const sources = [];

  if (videoTracks.some(track => track?._hubs_contentHint === MediaDevices.CAMERA)) {
    sources.push(MediaDevices.CAMERA);
  }

  if (videoTracks.some(track => track?._hubs_contentHint === MediaDevices.SCREEN)) {
    sources.push(MediaDevices.SCREEN);
  }

  return sources;
}

export function getLocalVideoSharingSource(mediaDevicesManager) {
  const sources = getLocalVideoSharingSources(mediaDevicesManager);

  return sources.includes(MediaDevices.SCREEN) ? MediaDevices.SCREEN : sources[0] || null;
}

export function hasLocalScreenShare(mediaDevicesManager) {
  return getLocalVideoSharingSources(mediaDevicesManager).includes(MediaDevices.SCREEN);
}

export function hasLocalCameraShare(mediaDevicesManager) {
  return getLocalVideoSharingSources(mediaDevicesManager).includes(MediaDevices.CAMERA);
}
